<template>
  <md-dialog :md-active.sync="showDialog">
    <div class="dialog-content">
      <h1>{{ $t("headline") }}</h1>
      <p class="md-body-1">{{ $t("intro") }}</p>
      <form @submit="formHandler">
        <md-field>
          <label for="name"> Name:</label>
          <md-input
            type="text"
            id="name"
            name="name"
            autocomplete="name"
            :placeholder="$t('fullName.label')"
            v-model.trim="$v.name.$model"
          />
          <span class="error" v-if="$v.name.$error">{{
            $t("fullName.error")
          }}</span>
        </md-field>
        <md-datepicker
          v-model.trim="$v.birthday.$model"
          md-immediately
          :md-model-type="String"
        >
          <label>{{ $t("birthday.label") }}</label>
          <span class="error" v-if="$v.birthday.$error">{{
            $t("birthday.error")
          }}</span>
        </md-datepicker>
        <md-field>
          <label for="name"> E-Mail:</label>
          <md-input
            type="email"
            name="email"
            autocomplete="email"
            placeholder="some@domain.tld"
            v-model.trim="$v.email.$model"
          />
          <span class="error" v-if="$v.email.$error">{{
            $t("email.error")
          }}</span>
        </md-field>
        <md-button class="md-raised md-primary" type="submit">{{
          $t("createCertificate")
        }}</md-button>
      </form>
    </div>
  </md-dialog>
</template>

<i18n>
{
  "en": {
    "headline": "You did it!",
    "intro": "Congratulations! You have successfully passed the theory test. Please generate your certificate now and send it together with all required documents to the office at least 15 days before the course begins.",
    "fullName": {
      "label": "First and last name",
      "error": "Please enter your name"
    },
    "birthday": {
      "label": "Birthday",
      "error": "Please enter your date of birth"
    },
    "email": {
      "error": "Please enter your e-mail address"
    },
    "createCertificate": "Create certificate"
  },
  "de": {
    "headline": "Geschafft!",
    "intro": "Herzlichen Glückwunsch! Du hast die Theorieprüfung erfolgreich bestanden. Erstelle dir jetzt dein Zertifikat und sende es zusammen mit den weiteren erforderlichen Nachweisen spätestens 15 Tage vor Lehrgangsbeginn an die Geschäftsstelle.",
    "fullName": {
      "label": "Vor- und Nachname",
      "error": "Bitte Name eingeben"
    },
    "birthday": {
      "label": "Geburtstag",
      "error": "Bitte Geburtsdatum eingeben"
    },
    "email": {
      "error": "Bitte E-Mail eingeben"
    },
    "createCertificate": "Zertifikat erstellen"
  }
}
</i18n>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  props: {
    identifier: {
      type: String,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    formHandler: function (event) {
      event.preventDefault();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.$store.dispatch(`${this.identifier}/generateCertificate`, {
        questionnaire: this.identifier,
        name: this.name,
        birthday: this.birthday,
        email: this.email,
        dt: new Date().toISOString(),
      });
      this.trail({
        type: "questionnaire-certified",
        questionnaire: this.identifier,
      });
      this.$router.push(`/${this.identifier}/certificate`);
    },
  },
  data: () => ({
    name: "",
    birthday: null,
    email: "",
  }),
  validations: {
    name: { required },
    birthday: { required },
    email: { required },
  },
};
</script>
<style scoped>
.dialog-content {
  padding: 2%;
}
.error {
  position: absolute;
  bottom: -22px;
  color: red;
}
</style>
